import { API } from "aws-amplify";
import { getOrganization } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_ORGANIZATION: APITypes.Organization = {
  id: "",
  name: "",
  createdAt: "",
  updatedAt: "",
  __typename: "Organization",
  _version: 0,
  _lastChangedAt: 0,
};

export const getOrganizationDetails = async (organizationID: string) => {
  try {
    const response = (await API.graphql({
      query: getOrganization,
      variables: { id: organizationID },
    })) as { data?: APITypes.GetOrganizationQuery };

    return {
      success: true,
      data: response.data?.getOrganization || EMPTY_ORGANIZATION,
    };
  } catch (error) {
    console.error("Error fetching organization details:", error);
    return {
      success: false,
      data: EMPTY_ORGANIZATION,
      error,
    };
  }
};
